export default "__VITE_ASSET__185883f1__"